<body>
  <header class="header">
    <div class="header__wrapper">
      <div class="header__logo">
        <img src="assets/images/logo_dark.png?v=2103" alt="GenAI Developer Booster" width="942" height="399">
      </div><!-- end of header__logo -->
      <shared-navuser></shared-navuser>
    </div>
  </header>
  <shared-taskbar [currentAgent]="'refactor'"></shared-taskbar>
  <router-outlet></router-outlet>
  <shared-sidebar></shared-sidebar>
</body>
